import React from "react";
import SectionCommonTable from "../../components/SectionCommonTable";
import AutoPoolBonusTable from "./Table/autoPoolBonusTable";

const AutoPoolBonus = () => {
  return (
    <SectionCommonTable
      wrapperClassName="autopoolbonus_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="Auto Pool Bonus"
      table={<AutoPoolBonusTable />}
    />
  );
};

export default AutoPoolBonus;
